<div class="catenary-generator">
  <div class="chart-container">
    <div class="chart-header">
      <h2 class="chart-title">{{ pageTitle | uppercase }}</h2>
      <div
        class="toggle-panel"
        *ngIf="!allCatenariesNoConverged && !simulationProblem && !serverFailed"
      >
        <!--<app-catenary-toggle-button
          [activated]="false"
          [disabled]="hasDefinedMeshHeatmap"
          class="toggle-panel-item"
          buttonType="desktop"
          (clicked)="toggleDesktopView()">
        </app-catenary-toggle-button>-->
        <app-catenary-toggle-button
          [disabled]="hasDefinedMeshHeatmap"
          class="toggle-panel-item"
          buttonType="floater"
          (clicked)="toggleChart('showFloaters')"
        >
        </app-catenary-toggle-button>
        <app-catenary-toggle-button
          [disabled]="hasDefinedMeshHeatmap"
          class="toggle-panel-item"
          buttonType="stiffener"
          (clicked)="toggleChart('showStiffeners')"
        >
        </app-catenary-toggle-button>
        <app-catenary-toggle-button
          [disabled]="hasDefinedMeshHeatmap"
          class="toggle-panel-item"
          buttonType="strake"
          (clicked)="toggleChart('showStrakes')"
        >
        </app-catenary-toggle-button>
        <app-catenary-toggle-button
          [disabled]="hasDefinedMeshHeatmap"
          class="toggle-panel-item"
          buttonType="stressjoint"
          (clicked)="toggleChart('showStressJoint')"
        >
        </app-catenary-toggle-button>
        <app-catenary-toggle-button
          [disabled]="hasDefinedMeshHeatmap"
          class="toggle-panel-item"
          buttonType="flexjoint"
          (clicked)="toggleChart('showFlexJoint')"
        >
        </app-catenary-toggle-button>
      </div>
    </div>
    <div class="chart-svg-wrapper" title="Scroll to zoom-in/out">
      <svg
        [ngClass]="{
          'svg-visible': !allCatenariesNoConverged && !simulationProblem && !serverFailed,
          'svg-hidden': allCatenariesNoConverged || simulationProblem || serverFailed
        }"
        class="catenary-plot"
      ></svg>
    </div>
    <div
      *ngIf="allCatenariesNoConverged || simulationProblem || serverFailed"
      class="chart-errors-container row center-xs"
    >
      <div class="col-xs-12">
        <i class="{{ noConvergenceIcon }} chart-error-icon"></i>
      </div>
      <h3 class="chart-error-title col-xs-12" *ngIf="allCatenariesNoConverged">
        Line {{ errorMessages.NO_CONVERGED | lowercase }}
      </h3>
      <h3 class="chart-error-title col-xs-12" *ngIf="serverFailed">
        {{ errorMessages.SERVER_FAILED }}
      </h3>
      <h3 class="chart-error-item col-xs-12" *ngFor="let item of serverErrors">
        {{ item }}
      </h3>
      <h3 class="chart-error-title col-xs-12" *ngIf="catenaryNoConverged">
        {{ errorMessages.SOME_NOT_CONVERGED }}:<br />
        {{ failedCatenaries }}
      </h3>
      <ng-container *ngIf="simulationProblem">
        <h3 class="chart-error-item col-xs-12">{{ errorTitle }}:</h3>
        <h4 class="chart-error-item col-xs-12" *ngIf="noConnections">
          - {{ errorMessages.NO_CONNECTION }}
        </h4>
        <h4 class="chart-error-item col-xs-12" *ngIf="noMaterial">
          - {{ errorMessages.NO_MATERIAL }}
        </h4>
        <h4 class="chart-error-item col-xs-12" *ngIf="noLine">- {{ errorMessages.NO_LINE }}</h4>
        <h4 class="chart-error-item col-xs-12" *ngIf="zeroProjection">
          - {{ errorMessages.ZERO_PROJECTION }}
        </h4>
      </ng-container>
    </div>
  </div>
</div>
